export const ADDBLOG = "blogs/addblog";

